import apiClient from "../../clients/apiClient";
import API_ENDPOINTS from "../../config/apiEndpointsConfig";

export const createMeasurementsEndpoint = async data => {
  const endpoint = API_ENDPOINTS.CREATE_MEASUREMENTS();
  try {
    const response = await apiClient.post(endpoint, data);
    return response;
  } catch (error) {
    throw new Error(`Error creating measurements: ${error.message}`);
  }
};

export const updateMeasurementsEndpoint = async data => {
  const endpoint = API_ENDPOINTS.UPDATE_MEASUREMENTS();
  try {
    const response = await apiClient.put(endpoint, data);
    return response;
  } catch (error) {
    throw new Error(`Error updating measurements: ${error.message}`);
  }
};

// Current measurements endpoints (for plan-based measurements in Align)
export const createCurrentMeasurementsEndpoint = async data => {
  const endpoint = API_ENDPOINTS.CREATE_CURRENT_MEASUREMENTS();
  try {
    const response = await apiClient.post(endpoint, data);
    return response;
  } catch (error) {
    throw new Error(`Error creating current measurements: ${error.message}`);
  }
};

export const updateCurrentMeasurementsEndpoint = async data => {
  const endpoint = API_ENDPOINTS.UPDATE_CURRENT_MEASUREMENTS();
  try {
    const response = await apiClient.put(endpoint, data);
    return response;
  } catch (error) {
    throw new Error(`Error updating current measurements: ${error.message}`);
  }
};

// Target measurements endpoints (for plan-based measurements in Align)
export const createTargetMeasurementsEndpoint = async data => {
  const endpoint = API_ENDPOINTS.CREATE_TARGET_MEASUREMENTS();
  try {
    const response = await apiClient.post(endpoint, data);
    return response;
  } catch (error) {
    throw new Error(`Error creating target measurements: ${error.message}`);
  }
};

export const updateTargetMeasurementsEndpoint = async data => {
  const endpoint = API_ENDPOINTS.UPDATE_TARGET_MEASUREMENTS();
  try {
    const response = await apiClient.put(endpoint, data);
    return response;
  } catch (error) {
    throw new Error(`Error updating target measurements: ${error.message}`);
  }
};

export const deleteMeasurementEndpoint = async measurementId => {
  const endpoint = API_ENDPOINTS.DELETE_MEASUREMENT(measurementId);
  try {
    const response = await apiClient.delete(endpoint);
    return response;
  } catch (error) {
    throw new Error(`Error deleting measurement: ${error.message}`);
  }
};
